import { render, staticRenderFns } from "./SDG.vue?vue&type=template&id=cac62eb8&scoped=true&"
import script from "./SDG.vue?vue&type=script&lang=js&"
export * from "./SDG.vue?vue&type=script&lang=js&"
import style0 from "./SDG.vue?vue&type=style&index=0&id=cac62eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac62eb8",
  null
  
)

export default component.exports